
import AVIframe from '@/components/AVIframe.vue';
import WLDomainCard from '@/components/our-rates/WLDomainCard.vue';
import Store from '@/store';
import { getPartnerDetailsResult } from '@homeserve/od-typings/api';
import { IDomain, IProductList } from '@homeserve/od-typings/api';
import { domainHelper, productListHelper } from '@homeserve/vue-api-plugin';
import WLProductList from '@homeserve/vue-components-plugin/src/components/WLHome/WLProductList.vue';
import { WLStickySupportPhone } from '@homeserve/vue-components-plugin/src/components/WLStickySupportPhone';
import { breadcrumbHelper } from '@homeserve/vue-components-plugin/src/main';
import GTMPageViewingMixin from '@homeserve/vue-components-plugin/src/mixins/GTMPageViewingMixin';
import { formatPhone } from '@homeserve/vue-components-plugin/src/utils/phoneHelper';
import { Component, Mixins } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

@Component({
  components: {
    AVIframe,
    WLDomainCard,
    WLProductList,
    WLStickySupportPhone,
  },
})
export default class OurRates extends Mixins(GTMPageViewingMixin) {
  @Getter('getDomains', { namespace: 'api/catalog/domain' })
  private domainList!: IDomain[];

  @Getter('productListsForPartner', { namespace: 'api/catalog/productList' })
  private productLists!: IProductList[];

  @Getter('partner')
  private partner!: getPartnerDetailsResult;

  private i18n: any;

  get topRepairs() {
    return this.productLists.find(list => list.name === 'top-depannages');
  }

  get supportPhone(): string {
    return formatPhone(this.partner.supportPhone, '0', true);
  }

  private async created() {
    this.i18n = {
      title: this.$t('our_rates.title'),
      desc: this.$t('our_rates.desc'),
      package_title: this.$t('our_rates.packages_title'),
      package_slot_normal_rate: {
        title: this.$t('our_rates.package_slot_normal_rate.title'),
        content: this.$t('our_rates.package_slot_normal_rate.content'),
      },
      package_slot_evening_saturday: {
        title: this.$t('our_rates.package_slot_evening_saturday.title'),
        content: this.$t('our_rates.package_slot_evening_saturday.content'),
      },
      package_slot_sunday: {
        title: this.$t('our_rates.package_slot_sunday.title'),
        content: this.$t('our_rates.package_slot_sunday.content'),
      },
      price_information: {
        title: this.$t('our_rates.price_information.title'),
        content: this.$t('our_rates.price_information.content'),
      },
      table_headers: {
        job: this.$t('our_rates.table_headers.job'),
        base_price: this.$t('our_rates.table_headers.base_price'),
        evening_saturday_price: this.$t('our_rates.table_headers.evening_saturday_price'),
        sunday_price: this.$t('our_rates.table_headers.sunday_price'),
        duration: this.$t('our_rates.table_headers.duration'),
        spare_parts: this.$t('our_rates.table_headers.spare_parts'),
      },
    };

    await breadcrumbHelper.setDomain(this.$store, '');
    await breadcrumbHelper.push(this.$store, {
      name: 'Tarifs dépannage',
      link: '/nos-tarifs',
    });
    await productListHelper.fetchProductListsForCurrentPartner(Store);
    await domainHelper.fetchDomains(Store);
  }
}
